/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberEight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M175.90234,130.00049a68.12024,68.12024,0,0,0-16.36377-11.356,58.78324,58.78324,0,0,0,9.83643-7.43994,53.63156,53.63156,0,0,0,0-79.0752,61.13213,61.13213,0,0,0-82.75,0,53.63156,53.63156,0,0,0,0,79.0752,58.76231,58.76231,0,0,0,9.83667,7.43994,68.1188,68.1188,0,0,0-16.364,11.35645,61.93012,61.93012,0,0,0,0,91.332,70.79516,70.79516,0,0,0,95.80468-.00049,61.93012,61.93012,0,0,0,0-91.332ZM97.57617,99.53955a37.63752,37.63752,0,0,1,0-55.74609,45.13922,45.13922,0,0,1,60.84766,0,37.63752,37.63752,0,0,1,0,55.74609,45.13783,45.13783,0,0,1-60.84766,0Zm67.375,110.12842a54.80089,54.80089,0,0,1-73.90234.00049,45.936,45.936,0,0,1,0-68.00293,54.80089,54.80089,0,0,1,73.90234-.00049,45.936,45.936,0,0,1,0,68.00293Z" />
    </Svg>
  );
}

export default NumberEight;
